<template>
  <login-panel back-route-name="sign-in" class="insert-user-data" xs>
    <div class="insert-user-data__content">
      <h3 class="insert-user-data__forgot-pass-text">
        {{ $t('login.forgot-password-text') }}
      </h3>
      <label for="usernameOrEmail" class="insert-user-data__label">
        {{ $t('login.username-or-email') }}
      </label>
      <b-form-input
        id="usernameOrEmail"
        type="text"
        v-model="usernameOrEmail"
        :state="$bsStateValidator($v.usernameOrEmail.$error)"
        @input="$v.usernameOrEmail.$touch()"
        maxlength="100"
      ></b-form-input>
      <b-button
        id="next"
        variant="primary"
        class="insert-user-data__btn-sign-in"
        :disabled="$v.$invalid"
        @click="validateUser()"
      >
        {{ $t('general.next') }}
      </b-button>
    </div>
  </login-panel>
</template>
<style lang="sass" scoped>

  .insert-user-data
    &__content
      margin-top: 30px
      display: flex
      flex-direction: column
      justify-content: center
      max-width: 100%
    &__forgot-pass-text
      text-align: center
      font-weight: 600
      margin-bottom: 25px
      font-size: 1.1em
    &__btn-sign-in
      margin: 30px 0 50px 0
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import LoginPanel from '@/components/LoginPanel';
import PasswordRecoverService from '@/domain/services/login/passwordRecoverService';

export default {
  components: {
    LoginPanel,
  },
  validations: {
    usernameOrEmail: {
      required,
    },
  },
  props: {},
  data() {
    return {
      usernameOrEmail: '',
    };
  },
  computed: {
    ...mapGetters([
      'isOffLineMode',
      'recoverData',
    ]),
  },
  methods: {
    ...mapActions([
      'setRecoverData',
    ]),
    validateUser() {
      PasswordRecoverService.validateUser(this.usernameOrEmail)
        .then((data) => {
          this.setRecoverData({
            secretQuestion: data.secretQuestion,
            username: data.username,
            email: data.email,
          });
          if (data.blocked) {
            this.$pushAlert({
              code: 'ME004',
              messageParams: { username: this.usernameOrEmail },
            });
            return;
          }

          if (this.isOffLineMode) {
            this.modeOfflineHandle();
            return;
          }

          this.$router.push({
            name: 'retrieve-options',
          });
        });
    },
    modeOfflineHandle() {
      if (this.recoverData.secretQuestion) {
        this.$router.push({
          name: 'answer-secret-question',
        });
        return;
      }
      this.$pushAlert({ code: 'ME009' });
    },
  },
};
</script>
